import { Matter } from "./Matter";
import { User } from "./User";

export const teamMemberRoles = ["owner", "admin", "editor", "viewer"] as const;
export type TeamMemberRole = (typeof teamMemberRoles)[number];

export interface TeamMember {
  _id: string;
  role: TeamMemberRole;
  user?: User;
  email: string;
  matter: Matter["_id"];

  createdAt: Date;
  createdBy: string;
  updatedAt: Date;
  updatedBy: string;
}
